<!-- グローバルナビゲーション -->
<template>
    <div id="global-navi-view">
        <div id="globalNaviWrapper">
            <div id="globalNaviLogo">
                <router-link to="/top">
                    BACS
                </router-link>
            </div>
            <div
                id="globalNaviMenu"
                @click="$emit('show-side-menu')"
            >
                メニュー
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GlobalNaviView',
    emits: ['show-side-menu']
}
</script>

<style scoped>
</style>
